export enum eAdministrationTab {
  tenantSettings = 'tenant-settings',
  individualisation = 'individualisation',
  projectTypes = 'project-types',
  estimationMethodologies = 'estimation-methodologies',
  estimationModels = 'estimation-models',
  users = 'users',
  workflow = 'workflow',
  aiWizard = 'ai-wizard',
  exportSettings = 'export-settings',
  notificationSettings = 'notification-settings',
  notificationTemplates = 'notification-templates',
  notifications = 'notifications',
  tipsNews = 'tips-news',
  usageAnalytics = 'usage-analytics',
}
